import { React, useState, useEffect, useRef } from 'react';
import IconButton from '../shared/IconButton/IconButton';

// import bg from '../../images/settingsBg.png'
import button_close from '../../images/icones/button_close.png'



// import checkerBg from '../../images/checkerBg.png'
// import checkerCompleted from '../../images/checkerCompleted.png'
// import checkerIndicator from '../../images/checkerIndicator.png' 


import Texts from 'react-sdk/Texts';

import './PopupSettings.css'
import AppState from '../../js/AppState';


const LabelChecker = ({ label, initialChecked=false, toggleCallback }) => {

  const [checked, setChecked] = useState(initialChecked);

  useEffect(() => {
    if(toggleCallback)
      toggleCallback(checked)
  }, [checked])

  return (
    <div className="LabelChecker">
      {label}
      <div className={ "checker" + (checked? " checked" : "")} onClick={ () => setChecked(!checked) }>
        <div class="handle"></div>
      </div>    
    </div>
  );
}

const PopupSettings = () => {
  
  return ( 
    <div className="PopupSettings">
      <div className="Popup">
        {/* <img src={bg} /> */}
        { <div className="settings">
          <div className="title">{ Texts.get("settings-title") }</div>

          <LabelChecker label={Texts.get("subtitles")} initialChecked={AppState.subtitles_visible} toggleCallback={(checked) => { AppState.subtitles_visible = checked }} />
          <LabelChecker label={Texts.get("sound")} initialChecked={AppState.sound} toggleCallback={(checked) => { AppState.sound = checked }} />

          {/* <div className="quit" onClick={ () => AppState.quit() }> { Texts.get("quit") } </div> */}
        </div>}
        <IconButton className={"settings-close"} icon={button_close} onClick={() => AppState.setPopup(null) } />
      </div>
    </div>
  );
};

export default PopupSettings